export default __webpack_public_path__ + "static/62908-c30a6f1a7f7490c202bcfb409aae8224.jpg";